import { Route } from '@angular/router';

export const callbackRoute: Route = {
  path: 'callback',
  pathMatch: 'full',
  redirectTo: '/home',
};
